import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useCustomerAuthStore } from './customerAuthStore';
import { bootstrapPortalSession } from './portalApolloClient';

import { SplashScreen } from '@/shared/ui/SplashScreen';

export function RequireCustomerAuth(): JSX.Element {
  const access_token = useCustomerAuthStore((s) => s.access_token);
  const [checking, setChecking] = useState(!access_token);

  useEffect(() => {
    if (access_token) return;
    let active = true;
    void bootstrapPortalSession().finally(() => {
      if (active) setChecking(false);
    });
    return () => {
      active = false;
    };
  }, [access_token]);

  if (access_token) return <Outlet />;
  if (checking) return <SplashScreen />;
  return <Navigate to="/portal/login" replace />;
}
